module.exports = __webpack_public_path__ + "static/banner-702a912f0d3c25e341fe581603e42f85.webm";